import { useMemo } from 'react';
import { FAST_USER_INTERACTION_DEBOUNCE } from '../../../../constants';
import { useDebouncedValue } from '../../../../hooks/useDebounceValue';
import { useHannibalQuery } from '../../../../schema/hannibal/HannibalContext';
import { AllSuggestionsBetaDocument } from '../../../../schema/hannibal/types.generated';
import { EMPTY_LIST } from '../../../../util/EMPTY_LIST';
import { mapProfileSuggestionsToSuggestionData } from '../PracticeSuggestions/PracticeSuggestions';
import { SuggestionList } from '../SuggestionList/SuggestionList';
import { TabProps } from '../TabProps';
import { useTextSuggestion } from '../useTextSuggestion';

export const AllSuggestionsBeta = ({ searchTerm, onChoose, trackingData }: TabProps) => {
  const query = useDebouncedValue(searchTerm, FAST_USER_INTERACTION_DEBOUNCE);
  const { data } = useHannibalQuery(AllSuggestionsBetaDocument, { variables: { query } });

  const profiles = data?.searchText.profiles ?? EMPTY_LIST;

  const allSuggestions = useMemo(
    () => mapProfileSuggestionsToSuggestionData(profiles).slice(0, 10),
    [profiles],
  );

  const allResults = useTextSuggestion(searchTerm, allSuggestions);
  return (
    <SuggestionList
      suggestions={allResults}
      onChoose={onChoose}
      trackingData={trackingData}
      searchTerm={searchTerm}
    />
  );
};
